import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetOfficeEquipmentModelsInput, OfficeEquipmentModelInput, OfficeEquipmentModelResult, Result, ResultList, SingleResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class OfficeEquipmentModelService {

  constructor(private httpClient: HttpClient) { }

  public addOfficeEquipmentModel(officeEquipmentModelInput: OfficeEquipmentModelInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentModel/AddOfficeEquipmentModel', officeEquipmentModelInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editOfficeEquipmentModel(id: number, officeEquipmentModelInput: OfficeEquipmentModelInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'OfficeEquipmentModel/EditOfficeEquipmentModel?id=' + id, officeEquipmentModelInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteOfficeEquipmentModel(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'OfficeEquipmentModel/DeleteOfficeEquipmentModel?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getOfficeEquipmentModel(id: number): Promise<SingleResult<OfficeEquipmentModelResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'OfficeEquipmentModel/GetOfficeEquipmentModel?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<OfficeEquipmentModelResult>(OfficeEquipmentModelResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<OfficeEquipmentModelResult>(OfficeEquipmentModelResult), result.error));
  }

  public getOfficeEquipmentModels(getOfficeEquipmentModelsInput: GetOfficeEquipmentModelsInput): Promise<ResultList<OfficeEquipmentModelResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentModel/GetOfficeEquipmentModels', getOfficeEquipmentModelsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OfficeEquipmentModelResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OfficeEquipmentModelResult>(), result.error));
  }
}
